import React from 'react';
import { HelpCircle } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Tengo que dejar de comer arroz y frijoles?',
    a: 'No. El protocolo le enseña cómo comerlos para que le den energía.'
  }, {
    q: '¿Necesito comprar suplementos caros?',
    a: 'No, todo lo que necesita está en su supermercado local.'
  }, {
    q: '¿Es difícil de seguir?',
    a: 'Es el método más sencillo del mundo: solo cambia el orden en que lleva la comida a su boca.'
  }, {
    q: '¿Cómo recibo el producto?',
    a: 'Es un libro digital (PDF). Lo recibe en su correo un segundo después de su compra.'
  }];
  return <section className="py-20 bg-gray-50 border-t border-gray-200" data-id="element-19">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <div className="max-w-3xl mx-auto" data-id="element-21">
          <div className="text-center mb-12" data-id="element-22">
            <HelpCircle className="w-12 h-12 text-green-600 mx-auto mb-4" data-id="element-23" />
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-24">
              Preguntas Frecuentes
            </h2>
          </div>

          <div className="space-y-6" data-id="element-25">
            {faqs.map((faq, index) => <div key={index} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-26">
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-27">
                  {faq.q}
                </h3>
                <p className="text-gray-700 text-lg leading-relaxed" data-id="element-28">{faq.a}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}